import React, { useState } from 'react';
import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout1Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout1: React.FC<FooterNavLayout1Props> = ({ colors }) => {
  const navItems = [
    { icon: FileText, label: 'History' },
    { icon: CheckSquare, label: 'All Bids' },
    { icon: Home, label: 'Home', active: true },
    { icon: Wallet, label: 'Wallet' },
    { icon: MessageCircle, label: 'Chat' }
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div className="px-4 py-2 rounded-2xl bg-white border"
         style={{ borderColor: colors.activeBackground, boxShadow: '0 10px 24px rgba(0,0,0,0.10)' }}>
      <div className="rounded-full px-6 py-1.5"
           style={{ backgroundColor: colors.background }}>
        <div className="flex items-center justify-between">
          {navItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = index === activeIndex;
            return (
              <button
                key={index}
                type="button"
                onClick={() => setActiveIndex(index)}
                className="flex items-center"
                style={{ background: 'transparent' }}
              >
                {isActive ? (
                  <div className="flex items-center gap-1 px-2 py-2 rounded-full"
                       style={{ backgroundColor: colors.activeBackground }}>
                    <Icon className="w-4 h-4" style={{ color: colors.activeText }} />
                    <span className="text-xs font-medium" style={{ color: colors.activeText }}>
                      {item.label}
                    </span>
                  </div>
                ) : (
                  <Icon className="w-4 h-4" style={{ color: colors.icon }} />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FooterNavLayout1;
